<script setup lang="ts">
const store = useStore()
async function logoutUser() {
  await store.logoutUser()
}
</script>

<template>
  <button class="oldskoolbutton" @click="logoutUser">
    <slot>Kirjaudu ulos</slot>
  </button>
</template>
